_getUserPortalMetaData